<template>
  <div class="full_page">
    <h3>Dispensary List</h3>
      <table class="table table-striped table-bordered table-hover table-condensed align_left">
        <thead>
        <tr>
          <th>#</th>
          <th>Visited</th>
          <th>License</th>
          <th>DBA</th>
          <th>Address</th>
          <th>Zone</th>
        </tr>
        </thead>
        <tbody class="align_left">
        <tr v-for="dispensary in road_data.list" v-bind:key="dispensary.pos">
          <td>{{dispensary.pos}}</td>
          <td>{{dispensary.Visited}}</td>
          <td style="cursor: pointer; text-decoration: underline; white-space:nowrap;" v-on:click="get_roads_details(dispensary.License,dispensary.id)">{{dispensary.License}}</td>
          <td>{{dispensary.DBA}}</td>
          <td>{{dispensary.Address}}</td>
          <td style="white-space:nowrap;">{{dispensary.Zone}}</td>
        </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      road_data: 'admin/road_data',
      road_data_loading: 'admin/road_data_loading',
    }),
  },
  watch: {
  },
  mounted() {
    this.get_roads_data();
  },
  methods: {
    get_roads_data() {
      // if(this.road_data.length === 0) // we need to update if YES was set
      // {
        this.$store.dispatch('admin/getRoadData', {type: '0'});
      // }
    },
    get_roads_details (license_number,id) {
      this.$router.push({name: "roads_details", 'params':{'license_number': license_number, 'id': id} });
    },
  }
}
</script>


<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

</style>

